import React from 'react'
import TextLogo from './TextLogo.svg'

const Logo = (props: React.ComponentProps<'img'>)=>{
    return (
        <img {...props} src={TextLogo} />
    )
}

export default Logo